export default {
    id: null,
    name: null,
    username: null,
    email: null,
    role: {
        id: null,
        title: null,
    },
    country: {
        id: null,
        title: null,
    },
    school: {
        id: null,
        title: null,
    },
    courses: [],
    defaultLanguage : null,
    studentCourse: {
        id: null,
        title: null,
    },
    address: null,
    serial: null,
    enabled: null,
    locked: null,
    createdAt: null,
    password: null,
    passwordConfirmation: null,
    timezone: window.luxon.DateTime.local().zoneName,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js